import styled from 'styled-components'

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
`
